import React from "react";
import { homeImages } from "../constants/homeImages";
import "./WhyChooseUs.css";
import "./homeGraphic.css";

const whyImages = homeImages.whyChooseUs;

const WhyChooseUs = () => {
  const items = [
    {
      title: "Experienced Industry Professionals",
      text: "With years of experience in the event industry, our skilled team understands every detail required to plan and execute successful events with precision and confidence.",
      icon: "★",
    },
    {
      title: "Strategic Planning Approach",
      text: "We believe great events start with strong planning. Every event is carefully studied, planned, and structured to ensure smooth execution and flawless results.",
      icon: "★",
    },
    {
      title: "Creative & Customized Solutions",
      text: "We don't believe in one-size-fits-all. Each event is designed with fresh ideas and customized concepts that match your vision, brand, and expectations.",
      icon: "★",
    },
    {
      title: "End-To-End Event Management",
      text: "From concept to completion, we manage everything under one roof—planning, production, coordination, and execution—so you can enjoy a stress-free experience.",
      icon: "★",
    },
    {
      title: "Quality & Technical Excellence",
      text: "We use high-quality equipment, professional setups, and experienced technicians to deliver superior sound, lighting, décor, and overall production standards.",
      icon: "★",
    },
    {
      title: "Transparent & Reliable Execution",
      text: "We work with complete transparency, clear communication, and timely delivery. Our commitment is to deliver what we promise—without compromise.",
      icon: "★",
    },
    {
      title: "Client Satisfaction First",
      text: "Your satisfaction is our priority. We focus on building long-term relationships by consistently exceeding expectations and delivering memorable experiences.",
      icon: "★",
    },
    {
      title: "Affordable Price",
      text: "We offer high-quality event solutions at competitive and transparent prices. Our smart planning and efficient execution ensure the best value for your budget—without compromising on quality or experience.",
      icon: "★",
    },
  ];

  return (
    <section id="why-choose-us" className="why-choose-us">
      <div className="why-choose-us-container">
        <div className="section-header why-section-header">
          <h2 className="section-title">Why Choose Us?</h2>
          <div className="title-underline"></div>
        </div>
        <div className="why-grid">
          {items.map((item, index) => (
            <article key={item.title} className="why-card">
              <div className="why-card__graphic">
                {whyImages[item.title] ? (
                  <div className="home-graphic-wrap home-graphic-wrap--why-grid">
                    <img
                      src={whyImages[item.title]}
                      alt={item.title}
                      className="home-graphic-img"
                      decoding="async"
                      loading={index > 0 ? "lazy" : "eager"}
                    />
                  </div>
                ) : (
                  <div className="why-card__icon-fallback">
                    <span className="why-card__icon" aria-hidden="true">
                      {item.icon}
                    </span>
                  </div>
                )}
              </div>
              <div className="why-card__body">
                <h3 className="why-card__title">{item.title}</h3>
                <p className="why-card__text">{item.text}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
